<template lang="pug">
v-dialog(
  scrollable lazy
  :persistent='isModified'
  :fullscreen='isMobile'
  :transition='transition'
  v-model='dialog'
  :max-width='dialogMaxWidth'
)
  v-tooltip(slot='activator' bottom)
    v-btn.mx-0(slot='activator' icon flat)
      v-icon(small) {{ isComment ? 'fas fa-comment-alt' : 'far fa-comment-alt' }}
    span {{ isComment ?  `編輯` : `新增` }}評語

  v-card(@keyup.esc='close')
    //- 對話框標題列
    v-toolbar(color='primary' dark)
      v-btn(icon dark @click='close' :disabled='isLoading'): v-icon close
      v-toolbar-title 編輯評語 #[ModifiedDot(:show='isModified && !isLoading')]
      v-spacer
      v-toolbar-items
         v-btn(flat @click='save' v-if='comment' :loading='isLoading' :disabled='!valid')
          | {{ $t('saveAndPublish') }}

      v-menu(bottom right offset-y :disabled='isLoading')
        v-btn(slot='activator' icon): v-icon more_vert
        v-list
          v-list-tile(@click='remove')
            v-list-tile-action: v-icon(color='error') fas fa-trash-alt
            v-list-tile-title.error--text 移除評語

    //- 錯誤提示訊息
    v-alert(type='error' :value='true' v-if='comment === false' icon='warning') {{ $t('errorWhileLoading') }} {{ error }}
    v-alert(type='error' :value='true' v-else-if='isSaveFailed && error' icon='warning') {{ $t('failedToSave') }} {{ error.response }}

    //- 表單
    v-card-text(v-if='comment')
      v-form(ref='form' v-model='valid')
        v-container.pa-0
          v-layout(row wrap)
            v-flex(xs12)
              v-text-field(label='分數' v-model.trim.number='comment.score' type='number' autofocus @keyup.enter='save')
              v-textarea(label='內容' v-model.trim='comment.content')
              v-subheader.pl-1
                | 圖片 (
                span(v-if='Array.isArray(comment.imgBase64)') {{ comment.imgBase64.length }}
                span(v-else) 0
                span /{{ maxFileCount }}張)
              ImageSelectorMultiple(v-model='comment.imgBase64' :maxFileCount='maxFileCount')
      DebugCodeBlock(:value='comment')
    Loader(:show='comment === null')
</template>

<script>
import apis from '@/assets/js/apis'

import { formStatus } from '@/mixins/formStatus'
import Loader from '@/components/Loader.vue'
import ImageSelector from '@/components/ImageSelector.vue'
import ImageSelectorMultiple from '@/components/ImageSelectorMultiple.vue'

export default {
  name: 'EditCommentNew',
  data () {
    return {
      comment: null,
      isNew: false,
      maxFileCount: 3,
    }
  },
  props: {
    period: {
      type: Number,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    isComment: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    show () {
      this.clearError()
      this.imgBase64Size = null
      this.fetch()
    },
    async fetch () {
      const params = { formId: this.id, period: this.period }
      this.comment = null
      this.isModified = true
      try {
        this.comment = await apis.comment.get(params, this.token) || {}
        this.$nextTick(() => { this.isModified = false })
        this.isNew = !this.comment || Object.keys(this.comment).length === 0
      } catch (e) {
        this.error = e
        this.comment = false
      }
    },
    async save () {
      if (!this.valid || this.isSaving) return
      this.clearError()
      this.isSaving = true
      this.handleIsCommentEmpty()

      const body = { formId: this.id, period: this.period, comment: this.comment }

      try {
        await apis.comment.put(body, this.token)
        this.$emit('success', this.isNew ? 'newComment' : 'editComment')
        this.close()
      } catch (e) {
        this.isSaveFailed = true
        this.error = e
        this.isSaving = false
      }
    },
    async remove () {
      if (!confirm('是否確認移除此評語？')) return
      this.clearError()
      this.isSaving = true

      const body = { formId: this.id, period: this.period, comment: null }

      try {
        await apis.comment.put(body, this.token)
        this.$emit('success', 'delComment')
        this.close()
      } catch (e) {
        this.isSaveFailed = true
        this.error = e
        this.isSaving = false
      }
    },
    close () {
      this.dialog = false
      this.isSaving = false
      this.isModified = false
    },
    // 送出前檢查 comment 各欄位，若皆為空則將 comment 設為null
    handleIsCommentEmpty () {
      const comment = this.comment
      const result = Object.keys(comment).every(_ => {
        return [null, ''].some($ => comment[_] === $)
      })

      if (result) this.comment = result ? null : this.comment
      return result
    },
  },
  computed: {
    isLoading () {
      return (this.isSaving || !this.comment) && !this.error
    },
    dialogMaxWidth () {
      return 500
    },
  },
  watch: {
    comment: {
      handler () {
        this.isModified = true
      },
      deep: true,
    },
    dialog (self) {
      if (self) this.show()
    },
  },
  components: {
    Loader,
    ImageSelector,
    ImageSelectorMultiple,
  },
  mixins: [formStatus],
}
</script>
